// extracted by mini-css-extract-plugin
export var avatarContainer = "_i3-0";
export var avatarTypingWave = "_i3-i";
export var gray = "_i3-f";
export var green = "_i3-c";
export var icon = "_i3-9";
export var image = "_i3-1";
export var lg = "_i3-6";
export var md = "_i3-5";
export var presenceDot = "_i3-b";
export var red = "_i3-d";
export var sm = "_i3-4";
export var status = "_i3-a";
export var typingDot = "_i3-h";
export var typingPill = "_i3-g";
export var xl = "_i3-7";
export var xs = "_i3-3";
export var xxl = "_i3-8";
export var xxs = "_i3-2";
export var yellow = "_i3-e";